import { pList, rSorguInputlari, rValue } from '../../../../api/models/.catalog';
import { ActionSubTypes } from '../../../ActionSubTypes';
import Api from '../../../../api/ApiWrapper';
import { IApiAction, IPromiseAction } from '../../../../models/ActionModels';
import ActionFunctions from '../../../core/ActionFunctions';
import { IError } from '../../../../models/StateModels';
import { Collection } from '../../../../models/Collection';

export const action_async_start = (body: pList): IPromiseAction<pList> =>
  ActionFunctions.action_async_start_promise(
    ActionSubTypes.API_SORGUINPUTLARI,
    new Api.Veri.SorguInputlari().Request(body),
    false,
    false,
    body
  );

export const action_async_complete = (
  data: rValue<rSorguInputlari> | null | undefined,
  error: IError | null | undefined
): IApiAction<rSorguInputlari> =>
  ActionFunctions.action_async_complete_api<rSorguInputlari>(
    ActionSubTypes.API_SORGUINPUTLARI,
    { Data: new Collection(((data?.Value?.Data as unknown) as any) || []) },
    error
  );
